import GLightbox from "glightbox"

export const load = function() {
  const lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
  })
}

export default load